import React, { Component } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { connect } from 'react-redux';
import { RootActions } from '../../../shared/root-action';
import { bindActionCreators } from 'redux';
import Api from '../../../libraries/api';
import AuthHelper from '../../../libraries/auth-helper';
import { history } from '../../../shared/configure-store';
import Logo from '../../../images/logo-new.png';

import LoginVideo from '../../../video/login-video.mp4';
import './login.scss';

require('dotenv').config();

const validator = new SimpleReactValidator({
  locale: process.env.REACT_APP_LOCALE
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: {},
      email: '',
      password: '',
      persistence: false,
      showPassword: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
    this.handleLogIn = this.handleLogIn.bind(this);
  }

  handleLogIn = e => {
    e.preventDefault();
    if (!validator.allValid()) {
      this.setState({ errors: validator.getErrorMessages() });
      return false;
    }
    this.setState({ errors: {}, loading: true });
    const params = {
      email: this.state.email,
      password: this.state.password
    };
    Api.post('/login', params)
      .then(resp => {
        AuthHelper.setLogin(resp.data);
        AuthHelper.setProfile(resp.data);
        const user = JSON.parse(JSON.stringify(resp.data));
        this.props.setProfile(user);
        history.push('/');
      })
      .catch(err => {
        this.setState({ errors: err, loading: false });
      });
  };

  handleChange(e, prop) {
    this.setState({ [prop]: e.target.value });
  }

  handleChecked = name => e => {
    this.setState({ [name]: e.target.checked ? 1 : 0 });
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    const { email, password, showPassword, loading, errors } = this.state;
    return (
      <main className="login">
        <video
          className="video-bg"
          src={LoginVideo}
          autoPlay
          loop
          muted
          playsInline
        />
        <section>
          <img
            src={Logo}
            alt="Abadi Logo"
            className="logo mb-4"
          />
          <div className="container text-center">
            <h1 className="mb-4">Sign In</h1>
            {/* <p>Sign in and start managing your clients</p> */}
            <form name="login" id="login" noValidate>
              <div className="form-group">
                <label htmlFor="email" className="custom-label">USERNAME</label>
                <TextField
                  variant="outlined"
                  type="text"
                  id="email"
                  name="email"
                  placeholder="Your username here..."
                  onChange={e => this.handleChange(e, 'email')}
                  value={email}
                  fullWidth
                  InputProps={{
                    className: 'custom-input'
                  }}
                />
                {validator.message('email', email, 'email|required')}
                <div className="text-danger">{errors.email}</div>
              </div>
              <div className="form-group">
                <label htmlFor="adornment-password" className="custom-label">PASSWORD</label>
                <TextField
                  variant="outlined"
                  type={showPassword ? 'text' : 'password'}
                  id="adornment-password"
                  name="password"
                  placeholder="Your password here.."
                  onChange={e => this.handleChange(e, 'password')}
                  value={password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="btn-input"
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword}
                        >
                          {showPassword ? (
                            <i className="fas fa-eye"></i>
                          ) : (
                            <i className="fas fa-eye-slash"></i>
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                    className: 'custom-input'
                  }}
                  fullWidth
                />
                {validator.message('password', password, 'required')}
                <div className="text-danger">{errors.password}</div>
              </div>
              <div className="text-danger mb-2">{errors.message}</div>
              <button
                onClick={this.handleLogIn}
                className="btn btn-orange mt-3"
                disabled={loading && 'disabled'}
              >
                Login{' '}
                {loading && <i className="fa fa-spinner fa-spin"></i>}
              </button>
            </form>
          </div>
          <div className="text-center mt-3 font-weight-bold">www.abadisurvey.com</div>
        </section>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  profile_state: state.profile_state,
  role_state: state.role_state,
  permission_state: state.permission_state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(RootActions, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);